import api from "./api";

export const listBlogPosts = async ({ searchParam = "", status = "", pageNumber = 1 } = {}) => {
  const { data } = await api.get("/blog-posts", {
    params: { searchParam, status, pageNumber }
  });
  return data;
};

export const createBlogPost = async (post) => {
  const { data } = await api.post("/blog-posts", post);
  return data;
};

export const updateBlogPost = async (id, post) => {
  const { data } = await api.put(`/blog-posts/${id}`, post);
  return data;
};

export const deleteBlogPost = async (id) => {
  await api.delete(`/blog-posts/${id}`);
};

export const uploadBlogImagem = async (file) => {
  const formData = new FormData();
  formData.append("typeArch", "blog");
  formData.append("file", file);
  const { data } = await api.post("/blog-posts/upload-imagem", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.filename;
};
